import { Ellipsis } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface RoleplayMenuProps {
  onEdit: () => void;
  onDelete: () => void;
  canEdit?: boolean;
  onClone: () => void;
}

export function RoleplayMenu({
  onEdit,
  onDelete,
  canEdit = false,
  onClone,
}: RoleplayMenuProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div className="ml-1.5" style={{ zIndex: 49 }} onClick={handleClick}>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button
            size="icon"
            intent="secondary"
            variant="minimal"
            className="h-10 w-10 data-[state=open]:bg-gray-200"
          >
            <Ellipsis size={24} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          {canEdit && (
            <>
              <DropdownMenuItem onClick={onEdit}>
                Edit Collection
              </DropdownMenuItem>
            </>
          )}
          <DropdownMenuItem onClick={onClone}>
            Clone Collection
          </DropdownMenuItem>
          {canEdit && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                onClick={onDelete}
                className="text-destructive focus:text-destructive"
              >
                Delete Collection
              </DropdownMenuItem>
            </>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
